import { Theme } from './theme'

export const googleTheme: Theme = {
  app: {
    $bgColor: '#F0F4F9',
  },
  loadingSpinner: {
    $bgColor: '#ffffff',
    spinner: {
      $color: '#2962FF',
      $bgColor: '#ffffff',
    },
  },
  logo: {
    $svg: null,
  },
  infoPage: {
    $showAboveTitle: false,
  },
  resetPasswordPage: {
    $showAboveTitle: false,
  },
  container: {
    $bgColor: '#FFFFFF',
    $width: '500px',
    $height: 'auto',
    $padding: '50px',
    $borderRadius: '28px',
    $border: '1px solid rgba(230, 221, 249, 1)',
    $boxShadow: '2px 2px 10px 0px rgba(0, 0, 0, 0.07)',
    $margin: '0 auto',
    $color: '#444746',
  },
  title: {
    $fontSize: '24px',
    $lineHeight: '36px',
    $color: '#444746',
  },
  paragraph: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#444746',
  },
  label: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#444746',
  },
  input: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#444746',
    $padding: '10px 16px',
    $border: '1px solid #B7BDC6',
    $borderRadius: '4px',
    $error: {
      $border: '1px solid #D83535',
      $boxShadow: '0px 0px 0px 3px #FFB0B0',
      $color: '#941616',
    },
  },
  buttonsContainer: {
    $flexDirection: 'row',
    $justifyContent: 'flex-end',
    $alignItems: 'center',
    $gap: '20px',
  },
  button: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#ffffff',
    $padding: '10px 24px',
    $border: '0px',
    $borderRadius: '100px',
    $bgColor: '#2962FF',
    $hover: {
      $color: '#ffffff',
      $border: '0px',
      $bgColor: '#2962FF',
    },
    $disabled: {
      $color: '#F6F6F6',
      $border: '0px',
      $bgColor: '#ACB0B5',
    },
  },
  link: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#2962FF',
    $border: '0px',
    $borderRadius: '100px',
    $bgColor: 'transparent',
    $textDecoration: 'none',
    $hover: {
      $fontSize: '14px',
      $lineHeight: '20px',
      $color: '#2962FF',
      $border: '0px',
      $borderRadius: '100px',
      $bgColor: 'transparent',
    },
  },
  breakpoints: {
    mobile: 480,
    tablet: 1024,
    desktop: 1440,
  },
}
